import { ContactPermissions } from './contacts.permissions';
import { ContactRoles } from './contacts.roles';

export const contactMappings = {
  [ContactPermissions.UPDATE_CONTACT]: [ContactRoles.MANAGER],
};
